import React, { useMemo } from 'react';
import { Card, Stack } from 'react-bootstrap';
import fetchConfig from '../../../fetchConfig';

export default function Attachments({ data }){

  const token = useMemo(() => sessionStorage.getItem('kctoken'), []);

  const download = async (url, item) => {
    const resp = await fetch(fetchConfig.baseUrl + url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (resp.ok) {
      if (resp.headers.get('Content-Type') === 'application/octet-stream') {
        const blob = await resp.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = resp.headers.get('fileName')
          ? decodeURIComponent(resp.headers.get('fileName'))
          : item.name;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
          window.URL.revokeObjectURL(link);
        }, 200);
      }
    }
  };

  return (
    <Card className="mb-4">
      <Card.Header className="p-4">
        <Card.Title className='m-0'>Приложения</Card.Title>
      </Card.Header>
      <Card.Body className="p-4">
        <Stack gap={3}>
          {data.attachments.map((v, i) => <p
            className="text-primary text-decoration-underline"
            style={{ cursor: 'pointer', textUnderlinePosition: 'under', width: 'max-content', maxWidth: '100%' }}
            onClick={() => download(`/minioFiles/download/${v.id}`, v)}
          >
            Приложение {i+1}. {v.fileName}.pdf
          </p>)}
        </Stack>
      </Card.Body>
    </Card>
  )
}
